var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilLoginremActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "util-loginrem-active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--color-text-primary);}\n\t.st1{fill:#A0E73F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,23.6c-2.8-0.9-4.6-2.1-3.2-4.9C27.6,6.8,23,0.5,16.4,0.5c-6.8,0-11.3,6.6-5,18.2c2.1,3.9-2.3,4.8-6.8,5.9 c-4.6,1.1-4.2,3.5-4.2,7.8h21c0-0.4-0.1-0.8-0.1-1.2C21.3,28.2,22.5,25.5,24.5,23.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.6,25c3,0,5.5,2.5,5.5,5.5S34.6,36,31.6,36s-5.5-2.5-5.5-5.5S28.6,25,31.6,25 M31.6,22.6c-4.4,0-8,3.6-8,8 s3.6,8,8,8s8-3.6,8-8S36,22.6,31.6,22.6L31.6,22.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilLoginremActive);
export default __webpack_public_path__ + "static/media/util-loginrem-active.0dd08b317fdaa9c0b7cd3d51605777d2.svg";
export { ForwardRef as ReactComponent };